<div class="list-items">
  <div class="item-container">
    <ecp-cart-details-frame [frames]="framesCart$ | async"></ecp-cart-details-frame>
  </div>
</div>
